import { Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { formatTime } from '../../../utils/AppUtils';

type Props = {
    elapsedSec: number;
    totalSec: number | null;
};

export default function ElapsedTimeTracker({ ...props }: Props) {
    const elapsedMin = Math.floor(props.elapsedSec / 60);
    const elapsedSec = Math.floor(props.elapsedSec % 60);

    return (
        <Flex
            align="center"
            className="elapsed-time-tracker"
            fontWeight="600"
            gap="4px"
            transition="500ms opacity"
            w={'100px'}
            mt="-8px"
            p={0}>
            <Flex justify="end">
                <Text fontWeight={600} color="white" fontFamily={FONT_ENUM.REGULAR_HEADER}>
                    {elapsedMin}:
                </Text>
                <Text fontWeight={600} color="white" fontFamily={FONT_ENUM.REGULAR_HEADER}>
                    {elapsedSec.toString().padStart(2, '0')}
                </Text>
                <Text fontWeight={600} color="white" fontFamily={FONT_ENUM.REGULAR_HEADER}>
                    /{formatTime(props.totalSec!)}
                </Text>
            </Flex>
        </Flex>
    );
}
